module.exports = __webpack_public_path__ + "shanz/static/media/House Hold Gadgets.74975050.png";